var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4451_24649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 8.05587C5.83301 7.46643 6.06716 6.90113 6.48396 6.48433C6.90076 6.06753 7.46606 5.83337 8.05551 5.83337H15.2772C15.569 5.83337 15.858 5.89086 16.1277 6.00255C16.3973 6.11424 16.6423 6.27795 16.8487 6.48433C17.0551 6.69071 17.2188 6.93571 17.3305 7.20536C17.4422 7.47501 17.4997 7.76401 17.4997 8.05587V15.2775C17.4997 15.5694 17.4422 15.8584 17.3305 16.1281C17.2188 16.3977 17.0551 16.6427 16.8487 16.8491C16.6423 17.0555 16.3973 17.2192 16.1277 17.3309C15.858 17.4426 15.569 17.5 15.2772 17.5H8.05551C7.76364 17.5 7.47464 17.4426 7.20499 17.3309C6.93535 17.2192 6.69034 17.0555 6.48396 16.8491C6.27758 16.6427 6.11388 16.3977 6.00219 16.1281C5.89049 15.8584 5.83301 15.5694 5.83301 15.2775V8.05587Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.34333 13.9475C3.08779 13.8018 2.87523 13.5912 2.72715 13.3371C2.57906 13.0829 2.50071 12.7942 2.5 12.5V4.16667C2.5 3.25 3.25 2.5 4.16667 2.5H12.5C13.125 2.5 13.465 2.82083 13.75 3.33333",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4451_24649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/Duplicate.cba89a3aeb405248dcea30237592565b.svg";
export { ForwardRef as ReactComponent };